import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Testimonial } from '../../types/content';
interface TestimonialListProps {
  items: Testimonial[];
}
export function TestimonialList({
  items
}: TestimonialListProps) {
  const [featured, ...rest] = items;
  if (!featured) return null;
  return <div className="grid gap-5 lg:grid-cols-12" data-id="element-872" data-mp="384335cz1f8a">
      <figure className="flex flex-col rounded-[28px] bg-white p-8 shadow-card md:p-12 lg:col-span-7" data-id="element-873" data-mp="369d3cmuewxc">
        <span className="flex h-12 w-12 items-center justify-center rounded-[15px] bg-brand text-white" aria-hidden="true" data-id="element-874" data-mp="3blt568bs29at">
          <QuoteIcon className="h-6 w-6" data-id="element-875" data-mp="3ldp6ds95ufj9" />
        </span>
        <blockquote className="mt-8 type-quote text-ink" data-id="element-876" data-mp="3lfa0jgrkbwgl">{featured.quote}</blockquote>
        <figcaption className="mt-auto flex items-center gap-4 pt-10" data-id="element-877" data-mp="3glpacaw7o6ry">
          <Avatar item={featured} size="lg" data-id="element-878" data-mp="2sww8jxswr4pf" />
          <span data-id="element-879" data-mp="2svl744mxq91h">
            <span className="block type-h5 text-ink" data-id="element-880" data-mp="2nyl09ri9h29b">{featured.name}</span>
            <span className="block type-small text-muted" data-id="element-881" data-mp="2nybaa3x7uv3m">{featured.detail}</span>
          </span>
        </figcaption>
      </figure>
      <div className="grid gap-5 lg:col-span-5" data-id="element-882" data-mp="2kfqdgn0w52pa">
        {rest.map(item => <figure key={item.name} className="flex flex-col rounded-[28px] bg-white p-7 shadow-card" data-id="element-883" data-mp="2kdncx9243r6b">
            <blockquote className="type-feature-desc text-ink" data-id="element-884" data-mp="2p92r62417p39">“{item.quote}”</blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-885" data-mp="2u7w15kk40xyo">
              <Avatar item={item} size="sm" data-id="element-886" data-mp="1wjlzj6o8kc83" />
              <span data-id="element-887" data-mp="21gvxxbtlry82">
                <span className="block font-bold text-ink" data-id="element-888" data-mp="21gcfzv3yd9u1">{item.name}</span>
                <span className="block type-small text-muted" data-id="element-889" data-mp="26ggwvm8rw6ks">{item.detail}</span>
              </span>
            </figcaption>
          </figure>)}
      </div>
    </div>;
}
function Avatar({
  item,
  size
}: {
  item: Testimonial;
  size: 'sm' | 'lg';
}) {
  const box = size === 'lg' ? 'h-14 w-14 rounded-[16px]' : 'h-11 w-11 rounded-[13px]';
  if (item.avatar) {
    return <img src={item.avatar} alt="" className={`${box} shrink-0 object-cover`} data-id="element-890" data-mp="3lz26qgilnnvc" />;
  }
  return <span className={`${box} flex shrink-0 items-center justify-center bg-cream type-card-title text-ink`} aria-hidden="true" data-id="element-891" data-mp="1mubxcad37qyc">
      {item.name.charAt(0)}
    </span>;
}